import { render, staticRenderFns } from "./RealTimePanel.vue?vue&type=template&id=e8f382a0"
import script from "./RealTimePanel.vue?vue&type=script&lang=js"
export * from "./RealTimePanel.vue?vue&type=script&lang=js"
import style0 from "./RealTimePanel.vue?vue&type=style&index=0&id=e8f382a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports